
import { Building, CalendarCheck, Scale, Banknote, Users, Building2, Briefcase } from 'lucide-react';

export const HERO_TABS = [
    { id: 'Society', label: 'Society', icon: Users },
    { id: 'LandOwner', label: 'Land Owner', icon: Building },
    { id: 'Builder', label: 'Builder', icon: Building2 },
    { id: 'Agent', label: 'Agent', icon: Briefcase },
    { id: 'Investor', label: 'Investor', icon: Banknote },
];

export const SERVICES_DATA = [
    {
        title: 'Redevelopment',
        icon: Building,
        points: [
            'Infra evaluation',
            'Connecting Builders',
            'Feasibility analysis',
            'Legal documentation review'
        ]
    },
    {
        title: 'Project Management',
        icon: CalendarCheck,
        points: [
            'Timeline Management',
            'Budget monitoring',
            'Stakeholder Coordination',
            'Progress Tracking'
        ]
    },
    {
        title: 'Legal Assistance',
        icon: Scale,
        points: [
            'Regulatory compliance',
            'Permit assistance',
            'Legal documentation',
            'Property rights protection'
        ]
    },
    {
        title: 'Financial Consultation',
        icon: Banknote,
        points: [
            'Budget Planning',
            'Funding Assistance',
            'Financial transparency',
            'Cost effective solutions'
        ]
    }
];

export const NOTIFICATION_EMAIL = "info@excaliburprojects.com";
export const DASHBOARD_URL = "https://www.excaliburprojects.com/admin/dashboard";

